import api from 'clients/api/Api';

import { IFranchiseResponse } from 'domains/franchise';

const getAll = async () => {
  const { data } = await api.get<IFranchiseResponse>('cardio/Franchise');
  return data;
};

export const FranchiseService = { getAll };
